<template>
    <div class="login-container">
        <el-row class="login-box">
            <el-col :span='12' class="login-box-l">
                <div class="login-box-l-inner">
                    <h1 class="inner-title">AUTOINFO</h1>
                    <p class="inner-ftitle">An auto-industry expert serving you</p>
                    <div class="inner-icon-box">
                        <div class="inner-icon">
                            <div class="inner-img-box">
                                <img src="@/assets/images/Group 466.png" alt="">
                            </div>
                            <span>Comprehensive</span>
                        </div>
                        <div class="inner-icon">
                            <div class="inner-img-box">
                                <img src="@/assets/images/Group 469.png" alt="">
                            </div>
                            <span>Go Deep</span>
                        </div>
                        <div class="inner-icon">
                            <div class="inner-img-box">
                                <img src="@/assets/images/Group 468.png" alt="">
                            </div>
                            <span>Precise</span>
                        </div>
                    </div>
                    <div class="inner-us">
                        <h1 class="inner-us-title">Contact Us</h1>
                        <p class="inner-us-text">Ms.Li Wenjuan</p>
                        <p class="inner-us-text">Tel: 18322511031</p>
                        <p class="inner-us-text">Email: liwenjuan@catarc.ac.cn</p>
                    </div>
                </div>
            </el-col>
            <el-col :span='12' class="login-box-r">
                <div class="inner">
                    <div class="inner-title">
                        <img src="@/assets/images/Group1.png" alt="">
                    </div>
                    <div class="inner-login">
                        <el-form :model="form" :rules="rules" ref="form">
                            <el-form-item prop="username">
                                <el-input placeholder="account" v-model="form.username"> <i slot="prefix" class="el-input__icon el-icon-user-solid"></i></el-input>
                            </el-form-item>
                            <el-form-item style="margin-bottom:23px" prop="password">
                                <el-input placeholder="password" v-model="form.password" type="password" show-password> <i slot="prefix" class="el-input__icon el-icon-lock"></i></el-input>
                            </el-form-item>
                            <el-form-item style="margin-bottom:23px" prop="remember">
                                <el-checkbox v-model="form.remember"><span style="color:#000">Remember password</span></el-checkbox>
                            </el-form-item>
                            <el-form-item>
                                <el-button style="width:100%" type="primary" @click="loginBtn('form')" :loading="loading">Login</el-button>
                            </el-form-item>
                        </el-form>
                    </div>
                </div>
                <div class="inner-tip">China Automotive Industry Information Net. All rights Reserved.</div>

            </el-col>
        </el-row>
    </div>
</template>
<script>
import { EnglishLogin } from "@/api/login.js";
import {
  setUserInfo,
  restUserInfo,
  setUserState,
  restUserState,
  getUserState,
  getSecrecy,
  setSecrecy,
  restSecrecy, setToken,
} from "@/utils/auth.js";
export default {
    data() {
        return {
            form: {
                remember: false,
                username: "",
                password: "",
            },
            rules: {
                username: [
                    {
                        required: true,
                        message: "Account number cannot be empty",
                        trigger: "blur",
                    },
                ],
                password: [
                    {
                        required: true,
                        message: "Password cannot be empty",
                        trigger: "blur",
                    },
                ],
            },
            loading: false,
        };
    },
    created() {
        this.form.remember = getUserState();
        if (getUserState()) {
            this.form.username = getSecrecy().username;
            this.form.password = getSecrecy().password;
        }
    },
    methods: {
        loginBtn(formName) {
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    this.loading = true;
                    EnglishLogin(this.form)
                        .then((res) => {
                            if (res.code == 200) {
                                this.$message({
                                    showClose: true,
                                    message: "登录成功",
                                    type: "success",
                                });
                                setToken(res.token);
                                setUserInfo(res.userInfo);
                                // if (this.form.remember) {
                                //     setUserInfo(res.data);
                                //     setUserState(true);
                                //     setSecrecy(this.form);
                                // } else {
                                //     restUserInfo(res.data);
                                //     restUserState(true);
                                //     restSecrecy(this.form);
                                // }
                                window.location='/';
                            }
                            this.loading = false;
                        })
                        .catch((err) => {
                            this.loading = false;
                        });
                }
            });
        },
    },
};
</script>
<style lang="less" scope>
@blue: #0d57bc;

.login-container,
.login-box {
    width: 100%;
    height: 100%;
    &-l {
        position: relative;
        height: 100%;
        background: url("../../assets/images/Group 890.png") no-repeat;
        background-size: cover;
        &-inner {
            position: relative;
            top: 180px;
            left: 96px;
            color: #fff;
            .inner-title {
                font-weight: bold;
                font-size: 40px;
                line-height: 45px;
                letter-spacing: 0.15em;
                font-style: oblique;
                margin-bottom: 8px;
            }
            .inner-ftitle {
                font-size: 19px;
                line-height: 21px;
                margin-bottom: 24px;
            }
            .inner-icon {
                display: flex;
                align-items: center;
                margin-bottom: 20px;
            }
            .inner-icon-box {
                display: flex;
                align-content: center;
                flex-direction: column;
                .inner-img-box {
                    width: 15px;
                    height: 15px;
                    text-align: center;
                    margin-right: 6px;
                    img {
                        max-width: 100%;
                        vertical-align: middle;
                    }
                }
                span {
                    font-size: 15px;
                    line-height: 15px;
                }
            }
            .inner-us {
                width: 310px;
                height: 182px;
                background: rgba(255, 255, 255, 0.2);
                margin-top: 43px;
                padding: 24px 25px;
                .inner-us-title {
                    font-weight: bold;
                    margin-bottom: 24px;
                }
                .inner-us-text {
                    margin-bottom: 14px;
                }
            }
        }
    }
    &-r {
        display: flex;
        position: relative;
        height: 100%;
        background: url("../../assets/images/Group.png") no-repeat center top;
        background-size: 543px 362px;
        .inner {
            margin: auto;
            display: flex;
            flex-direction: column;
            align-content: center;
            .inner-title {
                text-align: center;
                margin-bottom: 90px;
            }
            .inner-login {
                width: 360px;
                .el-input__prefix,
                .el-input__suffix {
                    color: @blue;
                }
                .el-form-item {
                    margin-bottom: 28px;
                }
            }
        }
        .inner-tip {
            position: absolute;
            left: 0;
            bottom: 29px;
            width: 100%;
            text-align: center;
            font-size: 16px;
            line-height: 24px;
            color: #bdbdbd;
        }
    }
}
</style>